import src from "IMAGE";
export default { src, width: 422, height: 609, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
